export const GERMANY_TIME_ZONE = 'Europe/Berlin';
export const _MS_PER_DAY = 1000 * 60 * 60 * 24;
